import { Button, Checkbox, IconButton } from "@design";
import { Plus, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { withForm } from "@/components/form/form";
import { Text } from "@/components/Text";
import { toValues } from "./connectorValues";

const emptyRow = () => ({ key: crypto.randomUUID(), name: "", label: "", default: "", header: "", required: false });

/** The settings a connector lets each space set (phase 4): name, label, default, optional header. */
export const SettingsEditor = withForm({
  defaultValues: toValues(),
  render: function SettingsEditorRender({ form }) {
    const { t } = useTranslation("connectors");
    return (
      <fieldset className="flex flex-col gap-3">
        <legend className="mb-1">
          <Text as="span" variant="body">
            {t("form.settings.title")}
          </Text>
        </legend>
        <Text variant="caption" tone="tertiary">
          {t("form.settings.hint")}
        </Text>
        <form.Field name="settings" mode="array">
          {(list) => (
            <>
              {list.state.value.map((row, i) => (
                <div key={row.key} className="flex flex-col gap-3 rounded-lg border border-border-subtle p-3">
                  <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <form.AppField name={`settings[${i}].name`}>
                      {(field) => <field.TextField label={t("form.settings.name")} required />}
                    </form.AppField>
                    <form.AppField name={`settings[${i}].label`}>
                      {(field) => <field.TextField label={t("form.settings.label")} required />}
                    </form.AppField>
                    <form.AppField name={`settings[${i}].default`}>
                      {(field) => <field.TextField label={t("form.settings.default")} />}
                    </form.AppField>
                    <form.AppField name={`settings[${i}].header`}>
                      {(field) => <field.TextField label={t("form.settings.header")} />}
                    </form.AppField>
                  </div>
                  <div className="flex items-center justify-between">
                    <form.Field name={`settings[${i}].required`}>
                      {(field) => (
                        <Checkbox
                          label={t("form.settings.required")}
                          checked={field.state.value}
                          onChange={field.handleChange}
                        />
                      )}
                    </form.Field>
                    <IconButton
                      icon={<Trash2 />}
                      variant="ghost"
                      size="sm"
                      aria-label={t("form.settings.remove", { label: row.label || row.name || String(i + 1) })}
                      onClick={() => list.removeValue(i)}
                    />
                  </div>
                </div>
              ))}
              <div>
                <Button
                  variant="secondary"
                  size="sm"
                  leadingIcon={<Plus size={14} />}
                  onClick={() => list.pushValue(emptyRow())}
                >
                  {t("form.settings.add")}
                </Button>
              </div>
            </>
          )}
        </form.Field>
      </fieldset>
    );
  },
});
